export default function initInputFields() {
  const fields = document.querySelectorAll(`.nio-full-page .text-field`);
  fields.forEach((field) => {
    const input = field.querySelector("input");

    input.addEventListener("focus", () => {
      field.classList.add("text-field--focused");
    });
    input.addEventListener("blur", () => {
      field.classList.remove("text-field--focused");
    });
  });
}
